import { render, staticRenderFns } from "./Girlboy.vue?vue&type=template&id=18cc3937&lang=pug&"
import script from "./Girlboy.vue?vue&type=script&lang=js&"
export * from "./Girlboy.vue?vue&type=script&lang=js&"
import style0 from "./Girlboy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports